export default __webpack_public_path__ + "static/SRF 3360PW - Product Specifications & Technical Data-2e384ab9d99c8480d9a5ae905428b853.pdf";